export const QuoteProductID = {
    HAVEN_TERM_PRODUCT_ID: 1031,
    BESTOW_PRODUCT_ID: 1032,
    LGA_PRODUCT_ID: 1033,
    HAVEN_SI_PRODUCT_ID: 1038
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/QuoteProductID.js